import type { PlanningTodoItem } from './planning-todo';
import { planningTodoTitle } from './planning-todo';

const PLANNING_INSTRUCTIONS = [
  'PLANNING MODE: You must NOT make any changes to the codebase, filesystem, or environment.',
  'Do not run tools that modify files or execute commands that change state.',
  'Your only task is to analyze and produce a plan.',
  '',
  'Respond with ONLY a single JSON array — no markdown fences, no other text before or after.',
  'Each array element must be an object with exactly:',
  '- "title": a one-line summary of the task',
  '- "prompt": the full prompt to use when creating a new draft session from this todo',
  '',
  'Example:',
  '[{"title":"Add user login","prompt":"Implement a login form with email and password..."}]',
].join('\n');

/** Agent-facing prompt for the first planning-session turn (bridge decrypts/enriches before send). */
export function buildPlanningSessionAgentPrompt(userPrompt: string): string {
  return [PLANNING_INSTRUCTIONS, '', 'User request:', userPrompt.trim()].join('\n');
}

/** Agent-facing prompt for planning-session follow-ups (includes existing todos). */
export function buildPlanningSessionFollowUpAgentPrompt(
  userPrompt: string,
  existingTodos: PlanningTodoItem[],
): string {
  const todoLines =
    existingTodos.length > 0
      ? existingTodos
          .map((t) => {
            const status = t.plannedSessionId ? 'DONE (draft session already created)' : 'OPEN';
            return `- [${status}] ${planningTodoTitle(t)}`;
          })
          .join('\n')
      : '(none yet)';

  return [
    PLANNING_INSTRUCTIONS,
    '',
    'Existing todo items from this planning session (consider these when responding; do not duplicate completed items):',
    todoLines,
    '',
    'User follow-up:',
    userPrompt.trim(),
  ].join('\n');
}
